import type { TFunction } from 'i18next'

/**
 * How a posted unit is named on every screen: its truck and the trailer it pulls — or,
 * for a straight box truck, which pulls none, the truck alone (TRKC-100). One function, so
 * the board, the posting's matches, the load's matches and the broadcast cannot drift.
 */
export function unitName(unit: { truckUnitNumber: string; trailerNumber: string | null }, t: TFunction): string {
  return unit.trailerNumber === null
    ? unit.truckUnitNumber
    : t('availability.unitPair', { truck: unit.truckUnitNumber, trailer: unit.trailerNumber })
}

/**
 * The equipment a posted unit offers, as every screen says it: the trailer's type, or a
 * straight box truck with its box beside it — "Straight box truck, 26 ft" (TRKC-102), the
 * length a broker filtering DAT for an SB looks for. One function for the same reason as above.
 */
export function unitEquipment(unit: { equipment: string; boxLengthFeet: number | null }, t: TFunction): string {
  const equipment = t(`carriers.types.${unit.equipment}`)
  return unit.boxLengthFeet === null ? equipment : t('availability.equipmentWithBox', { equipment, feet: unit.boxLengthFeet })
}
